// Fonction pour nettoyer le HTML de manière sécurisée
export const sanitizeHtml = (html) => {
  if (!html) return '';
  
  // Convertir les caractères spéciaux en entités HTML
  const div = document.createElement('div');
  div.textContent = html;
  const sanitized = div.innerHTML;
  
  // Autoriser uniquement certaines balises HTML
  return sanitized.replace(
    /&lt;(\/?)(p|br|strong|em|ul|ol|li|h[1-6]|blockquote)&gt;/gi,
    '<$1$2>'
  );
}; 